module.exports = __webpack_public_path__ + "static/15-fe3cc7fb007e2fd9e159b9d953899c48.jpg";